import {Injectable} from '@angular/core';
import {environment} from '../environments/environment';

const WWW = environment.WWW

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {

  leadCustomer() {
    if (location.href.includes(WWW)) {
      this.leadFacebook()
      this.leadCustomerGoogle()
    }
  }

  leadTeam() {
    if (location.href.includes(WWW)) {
      this.leadFacebook()
      this.leadTeamGoogle()
    }
  }

  conversionCustomer() {
    if (location.href.includes(WWW)) {
      this.conversionFacebook()
      this.conversionCustomerGoogle()
    }
  }

  conversionTeam() {
    if (location.href.includes(WWW)) {
      this.conversionFacebook()
      this.conversionTeamGoogle()
    }
  }

  leadFacebook() {
    try {
      (window as any)._fbq.push(['track', 'AddToCart', {}]);
    } catch (err) {
      console.error('[Analytic] Lead Facebook Error ', err);
    }
  }

  leadCustomerGoogle() {
    try {
      (window as any).gtag('event', 'conversion', {'send_to': 'AW-900169511/CW4WCOzZxmQQp_6drQM'});
    } catch (err) {
      console.error('[Analytic] Lead Customer Google Error ', err);
    }
  }

  leadTeamGoogle() {
    try {
      (window as any).gtag('event', 'conversion', {'send_to': 'AW-900169511/34W1CJvc2-waEKf-na0D'});
    } catch (err) {
      console.error('[Analytic] Lead Team Google Error ', err);
    }
  }

  conversionFacebook() {
    try {
      (window as any)._fbq.push(['track', 'CompleteRegistration', {}]);
    } catch (err) {
      console.error('[Analytic] Lead Facebook Error ', err);
    }
  }

  conversionCustomerGoogle() {
    try {
      (window as any).gtag('event', 'conversion', {'send_to': 'AW-900169511/k7q0CNmy2GQQp_6drQM'});
    } catch (err) {
      console.error('[Analytic] Conversion Customer Google Error ', err);
    }
  }

  conversionTeamGoogle() {
    try {
      (window as any).gtag('event', 'conversion', {'send_to': 'AW-900169511/H9quCOSWp-4aEKf-na0D'});
    } catch (err) {
      console.error('[Analytic] Conversion Team Google Error ', err);
    }
  }

}
